export default __webpack_public_path__ + "static/media/avatar_lion7.388ca941.mp3";